import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Table = styled.table`
  table-layout: fixed;
  text-align: left;
  width: 100%;

  @media (max-width: 600px) {
    display: none;
  }

  tr {
    margin-bottom: ${Spacing.Xxs};
  }
  th,
  td {
  }
  th:nth-child(1), // Appointment
  td:nth-child(1) {
    width: 13rem;
  }
  th:nth-child(2), // Branch
  td:nth-child(2) {
    width: 15%;
    > span {
      padding-left: ${Spacing.S};
    }
  }
  th:nth-child(3), // Notes
  td:nth-child(3) {
    width: 42%;
    > span {
      padding-left: ${Spacing.S};
    }
  }
  th:nth-child(4), // Partners + members
  td:nth-child(4) {
    width: 20%;
    > span {
      padding-left: ${Spacing.S};
    }
  }
  th:nth-child(5), // Arrow
  td:nth-child(5) {
    border-right: 1px solid ${Colors.blue['20']};
    justify-content: center;
    width: 3%;
  }
`;

export const ContainerHeader = styled.thead`
  align-items: center;
  display: flex;
  width: 100%;
`;

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xs};
  width: 100%;
`;

export const MobileCard = styled.div`
  background-color: ${Colors.white};
  border: 1px solid ${Colors.blue['20']};
  border-radius: ${Spacing.Xxs};
  cursor: pointer;
  padding: ${Spacing.Xxs};
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const MobileCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${Spacing.Xs};
`;

export const MobileCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xxs};
`;

export const MobileInfoRow = styled.div`
  align-items: flex-start;
  display: flex;
  gap: ${Spacing.Xs};
`;

export const MobileLabel = styled.div`
  flex-shrink: 0;
  font-weight: 600;
  width: 5rem;
`;

export const MobileValue = styled.div`
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
  word-wrap: break-word;
`;
